<div class="media-card-container">
	@if (label) {
		<h5>{{ label | translate }}</h5>
	}
	@if (media) {
		<div class="media-card">
			<ngx-media-thumbnail
				class="media-thumbnail"
				[media]="media"
			></ngx-media-thumbnail>
			<div class="media-title">
				{{ media.title }}
			</div>
		</div>
	}
</div>
